import * as React from 'react';
import { useSelector } from 'react-redux';

import { Avatar } from '../../../components/Avatar';
import { getReviewById } from '../../../selectors/reviews';

interface IAvatarContainerProps {
  reviewId: string;
}

export function AvatarContainer({ reviewId }: IAvatarContainerProps) {
  const { user } = useSelector(getReviewById(reviewId));

  return <Avatar avatarUrl={user.avatarUrl} type={user.type} />;
}
